<template>
  <div class="list">
    <UserProfileStatsTime :user="user" class="stats-time"/>

    <UserProfileStatsCourses :user="user"/>
  </div>
</template>

<script>
import UserProfileStatsTime from './UserProfileStatsTime'
import UserProfileStatsCourses from './UserProfileStatsCourses'

export default {
  components: {
    UserProfileStatsTime,
    UserProfileStatsCourses,
  },

  props: {
    user: { type: Object, required: true }
  }
}
</script>

<style lang="scss" scoped>
  .list {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }
  .stats-time {
    margin-bottom: 8px;
  }
</style>